import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Form from './StyledSearchForm'
import AutocompleteSearch from './Autocomplete/index'
import NormalSearch from './NormalSearch'
import SearchButton from './StyledSearchButton'
import DictionarySelect from './StyledDictionarySelect'
import { SECTION_NAMES, SERVICE_URL_PATTERN, SHOULD_SHOW_AUTOCOMPLETE_LOCALSTORAGE_KEY } from '../../../../constants'

class SearchForm extends PureComponent {
  constructor (props) {
    super(props)

    const shouldShowAutocomplete = this.getShouldShowAutocomplete(props.activeSection.name)

    this.state = {
      shouldShowAutocomplete
    }

    this.handleSearchFormSubmit = this.handleSearchFormSubmit.bind(this)
    this.handleDisableAutocompleteClick = this.handleDisableAutocompleteClick.bind(this)
  }

  componentWillReceiveProps (newProps) {
    this.setState({
      shouldShowAutocomplete: this.getShouldShowAutocomplete(newProps.activeSection.name)
    })
  }

  getShouldShowAutocomplete (name) {
    const isAutocomplete = name === SECTION_NAMES.INTERNET

    const autocompleteSetting = typeof window !== 'undefined'
      ? window.localStorage.getItem(SHOULD_SHOW_AUTOCOMPLETE_LOCALSTORAGE_KEY)
      : true

    return isAutocomplete && ((autocompleteSetting !== null) ? JSON.parse(autocompleteSetting) : true)
  }

  handleSearchFormSubmit () {
    this.searchForm.submit()
  }

  handleDisableAutocompleteClick () {
    if (typeof window !== 'undefined') {
      if (window.confirm('Opravdu chcete našeptávač vypnout?')) {
        this.setState({
          shouldShowAutocomplete: false
        })
        window.localStorage.setItem(SHOULD_SHOW_AUTOCOMPLETE_LOCALSTORAGE_KEY, 'false')
      }
    }
  }

  render () {
    const {
      activeSection: {
        name,
        params,
        url: searchUrl
      },
      activeSection,
      proxyOptions,
      utmMedium,
      utmSource
    } = this.props

    const {
      shouldShowAutocomplete
    } = this.state

    const SearchComponent = shouldShowAutocomplete ? (
      <AutocompleteSearch
        serviceUrlPattern={SERVICE_URL_PATTERN}
        activeSection={activeSection}
        handleDisableAutocompleteClick={this.handleDisableAutocompleteClick}
        handleSearchFormSubmit={this.handleSearchFormSubmit}
        proxyOptions={proxyOptions}
      />
    ) : <NormalSearch activeSection={activeSection}/>

    return (
      <Form
        action={searchUrl}
        method='GET'
        innerRef={form => { this.searchForm = form }}
      >
        { SearchComponent }
        {
          (name === SECTION_NAMES.DICTIONARIES && activeSection.dictionaries.length > 0) && (
            <DictionarySelect name='lang'>
              {
                activeSection.dictionaries.map(({ value, text }) => {
                  return (
                    <option key={`dictionary-${value}`} value={value}>
                      { text }
                    </option>
                  )
                })
              }
            </DictionarySelect>
          )
        }
        <SearchButton type='submit' value='Hledat'/>
        <input type='hidden' name='utm_source' value={utmSource}/>
        <input type='hidden' name='utm_medium' value={utmMedium}/>
        {
          Object.values(params).map(param => {
            return <input key={param.name} type='hidden' name={param.name} value={param.value}/>
          })
        }
      </Form>
    )
  }
}

SearchForm.propTypes = {
  activeSection: PropTypes.object.isRequired,
  utmMedium: PropTypes.string.isRequired,
  utmSource: PropTypes.string.isRequired
}

export default SearchForm
